import RequestType from "../constants/requestType";
import ApiService from "../services/apiService";

import { actionTypes } from '../constants/actionTypes';
import { apiRoutes } from '../constants/apiRoutes';
import { toastr } from 'react-redux-toastr'

const getLocations = () => {
  return async dispatch => {
    try {
      const response = await ApiService.performRequest(RequestType.GET, apiRoutes.locationRelated.list);

      dispatch({
        type: actionTypes.locationRelated.GET_LOCATIONS_SUCCESS,
        response
      });
    }
    catch (error) {
      toastr.error('Kon de locaties niet ophalen');

      dispatch({
        type: actionTypes.locationRelated.GET_LOCATIONS_FAIL
      });
    }
  }
};

export default {
  getLocations
}
